export default "__VITE_ASSET__0e10d1a6__"